import { Injectable } from "@angular/core";

import { getDialogFactoryBase } from "@logex/framework/ui-core";
import { LgPasteDialogComponent } from "./lg-paste-dialog.component";

@Injectable({ providedIn: "root" })
export class LgPasteDialogFactory extends getDialogFactoryBase(LgPasteDialogComponent, "show") {}
